import { openDB } from 'idb';

const DB_NAME = 'PaduaCheckInDB';
const DB_VERSION = 1;

export const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('contacts')) {
        const contactsStore = db.createObjectStore('contacts', { keyPath: 'contact_id' });
        contactsStore.createIndex('email', 'email');
        contactsStore.createIndex('phone', 'phone');
      }
      if (!db.objectStoreNames.contains('events')) {
        db.createObjectStore('events', { keyPath: 'event_id' });
      }
      if (!db.objectStoreNames.contains('registrations')) {
        const regStore = db.createObjectStore('registrations', { keyPath: 'registration_id' });
        regStore.createIndex('event_id', 'event_id');
        regStore.createIndex('contact_id', 'contact_id');
      }
      if (!db.objectStoreNames.contains('relationships')) {
        db.createObjectStore('relationships', { keyPath: 'contact_id' });
      }
      if (!db.objectStoreNames.contains('activity')) {
        const activityStore = db.createObjectStore('activity', { keyPath: 'activity_id' });
        activityStore.createIndex('event_id', 'event_id');
      }
      if (!db.objectStoreNames.contains('imports')) {
        db.createObjectStore('imports', { keyPath: 'import_id' });
      }
    },
  });
};

export const getDB = async () => {
  return await initDB();
};